import { IPatientProfileInformationBean, IPatientProfileItemBean } from "../beans";
import { PatientProfileInformation, PatientProfileItem } from "../../../../domain/patient";

export class PatientProfileInformationTranslator {
  public toPatientProfileInformation(bean: IPatientProfileInformationBean): PatientProfileInformation {
    const items = bean ? this.toPatientProfileItems(bean.items) : [];
    const isInvalid = !bean;
    return new PatientProfileInformation(items, isInvalid);
  }

  private toPatientProfileItems(beans: IPatientProfileItemBean[]): PatientProfileItem[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toPatientProfileItem(bean));
  }

  private toPatientProfileItem(bean: IPatientProfileItemBean): PatientProfileItem {
    if (!bean) { return null; }
    const item = new PatientProfileItem();
    item.name = bean.name;
    item.value = bean.value;
    item.comment = bean.comment;
    item.isEnabled = !!bean.enabled;
    return item;
  }

  public toPatientProfileInformationBean(info: PatientProfileInformation): IPatientProfileInformationBean {
    const itemBeans = info ? this.toPatientProfileItemBeans(info.items) : [];
    const isInvalid = info ? info.isInvalid : true;
    return {
      items: itemBeans,
      isInvalid,
      isUpdated: info ? info.isUpdated : false
    };
  }

  private toPatientProfileItemBeans(items: PatientProfileItem[]): IPatientProfileItemBean[] {
    if (!items) { return []; }
    return items.map(item => this.toPatientProfileItemBean(item));
  }

  private toPatientProfileItemBean(item: PatientProfileItem): IPatientProfileItemBean {
    if (!item) { return null; }
    return {
      name: item.name,
      value: item.value,
      comment: item.comment,
      enabled: !!item.isEnabled,
    };
  }
}
